import { render, staticRenderFns } from "./FundPensionA.vue?vue&type=template&id=ba04c81e&scoped=true&"
import script from "./FundPensionA.vue?vue&type=script&lang=js&"
export * from "./FundPensionA.vue?vue&type=script&lang=js&"
import style0 from "./FundPensionA.vue?vue&type=style&index=0&id=ba04c81e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba04c81e",
  null
  
)

export default component.exports